/* eslint-disable no-unused-vars */
import React, { useRef, useState, useEffect } from 'react';
import $ from 'jquery';
import { useHistory,useNavigate } from 'react-router-dom';
import ROUTE from '../../utils/index';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import Tooltip from '@material-ui/core/Tooltip'
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { AlertDialogSlide } from './successAlert';
import {
  Box,
  Button,
  Checkbox,
  Container,
  FormHelperText,
  TextField,
  Typography,
  makeStyles,
  Grid,
  colors,
  Dialog,
  DialogActions,
  DialogContent,
  CardActions,
  CardMedia,
  Card,
  CardContent,

  InputAdornment
  // DatePicker,
} from '@material-ui/core';
// import DatePicker from '@material-ui/lab/DatePicker';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import ContactsOutlinedIcon from '@material-ui/icons/ContactsOutlined';
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
import BusinessOutlinedIcon from '@material-ui/icons/BusinessOutlined';
import GroupIcon from '@material-ui/icons/GroupOutlined';
import MonetizationOnOutlinedIcon from '@material-ui/icons/MonetizationOnOutlined';
import { FormValidationSchema } from "./ValidationSchema";
import { Questions } from '../commons/questions'
// import sha256 from 'crypto-js/sha256';
import Axios from 'axios';
import Page from '../../components/Page';
import MuiAlert from '@material-ui/lab/Alert';
import { countries } from '../../utils/countries'
import { nationalities } from '../../utils/nationalities'
import { currentDate, uniqueFormID } from '../../utils/currentDate'
import { Signature } from '../../utils/index'
import { states, sources, periods, mandates, incomes, idTypes, statuses, accountTypes } from '../../utils/data'
import { branches } from '../../utils/branches'
import { PreviewModal } from '../commons/preview'
import { Encryption } from '../../utils/index'
import GuideModal from '../pages/GuideModal';
import {  InputGroup, Row,Col} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useFormikContext } from 'formik';
import SignatureCanvas from 'react-signature-canvas';
import * as Yup from "yup";  
import RefreshIcon from "@material-ui/icons/Refresh";
function Alert(props) {
  return <MuiAlert elevation={0} variant="filled" {...props} />;
}


export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    "& > *": {
      marginRight: theme.spacing(3),
      marginLeft: theme.spacing(3),
    },
    fontFamily: 'Helvetica , sans-serif'
  },
  margin: {
    margin: theme.spacing(1),
    width: 220,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 230,
  },
  fulltextField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(2),

    margin: theme.spacing(1),
    // width: 200,
  },
  halftextField: {
    // marginLeft: theme.spacing(1),
    // marginRight: theme.spacing(1),
    margin: theme.spacing(1),
    width: 230,
  },
  halftextField1: {
    // marginLeft: theme.spacing(1),
    // marginRight: theme.spacing(1),
    margin: theme.spacing(1),
    width: 280,
  },
  details: {
    color: colors.grey[900],
    backgroundColor: colors.lime[500],
    display: 'flex',
    justifyContent: 'flex-start',
    fontWeight: 800,
  },
  contacts: {
    color: colors.grey[900],
    backgroundColor: colors.lightBlue[300],
    display: 'flex',
    justifyContent: 'flex-start',
    fontWeight: 700,
    fontSize: 12
  },
  textLower: {
    textTransform: 'lowercase',
    fontWeight: 500,
    fontSize: 12
  },
  upperCase: {
    textTransform: 'uppercase'
  },
  formTitle: {
    // color: "#FFFFFF",
    color: colors.lightBlue[600],
    marginLeft: theme.spacing(),
    flex: 1,
    fontWeight: 600
  },
  id: {
    // color: "#FFFFFF",
    color: colors.grey[400],
    fontWeight: 600,
    fontSize: 16,
  },
  snackFont: {
    fontSize: 16,
    fontWeight: 300,
    // color: colors.grey[900],
  },
  policyError: {
    color: colors.red[400],
    fontSize: 12,
  },

  formValue: {
    fontSize: 16,
    fontWeight: 600,
    // flex: 1,
    color: colors.grey[900],
    border: 0,
    resize: 'none',
    overflow: 'hidden',
    //padding: '-70px',
    backgroundColor: "#F4F6F8",
    //maxWidth: '100%'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  selectCard: {
    //maxWidth: 400,
    //margin: '0 auto',
    marginTop: theme.spacing(1),
    backgroundColor: "#ffffff",
    border: '1px solid #000000'
  },
}));

export const KycFormFields = () => {
  const classes = useStyles();
  const [selectedValue, setSelectedValue] = React.useState('');
  const [copySuccess, setCopySuccess] = useState('');
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackOpenError, setSnackOpenError] = useState(false);
  const [openSnack, setOpenSnack] = useState(false);

  const [formValues, setFormValues] = useState(null)
  const textAreaRef = useRef(null);

  const [openSuccess, setOpenSuccess] = useState(false);
  const [branchSortedArray, setBranchData] = useState([]);
  //let history = useHistory();
  const history= useNavigate();

  const [captchaText, setCaptchaText] = useState('');
  const [captchaInput, setCaptchaInput] = useState('');
  const canvasRef = useRef(null);

  const [captchaValue, setCaptchaValue] = useState("");



  useEffect(() => {
    // code to run after render goes here
    SortSelect();
    //generateCaptchaText();
    //setCaptchaValue(generateCaptchaText());

    const captcha = generateCaptchaText();
    setCaptchaValue(captcha);
  }, []); // <-- empty array means 'run once'

    // Redraw CAPTCHA every time the text changes
    /*useEffect(() => {
      if (captchaText) {
        drawCaptcha();
      }
    }, [captchaText]);*/

  const refreshPage = () => {
    // window.location.reload();
    history(ROUTE.index);
  }

  const handleCloseSuccess = () => {
    setOpenSuccess(false);
    refreshPage();
  };

  const handleOpenSuccess = () => {
    setOpenSuccess(true);
  };

  const handleDepositChoice = (event) => {
    setSelectedValue(event.target.value);
  };

  const copyCodeToClipboard = () => {
    textAreaRef.current.select();
    document.execCommand('copy');
    setCopySuccess('Copied!');
    setSnackOpen(true);
  }

  const handleCloseSnack = (e, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackOpen(false)
  }

  const handleOpenSnackError = () => {
    setSnackOpenError(true)
  }

  const handleCloseSnackError = (e, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackOpenError(false)
  }

  const SortSelect = () => {
    $("#elmt").append($("#elmt option")
      .remove().sort(function (a, b) {
        let at = $(a).text(),
          bt = $(b).text();
        return (at > bt) ? 1 : ((at < bt) ? -1 : 0);
      }));
  };

  const handleCloseSnackBar = () => {
    setOpenSnack(false);
  };

  const handleToggleSnackBar = () => {
    setOpenSnack(true);
  };





  const generateCaptchaText = () => {
    // Generate a random CAPTCHA string with letters and numbers
    const obscureChars = () =>
      Array.from({ length: 6 }, () =>
        Math.random().toString(36).charAt(Math.random() < 0.5 ? 2 : 10).toUpperCase()
      ).join(''); // Random 6-character string with uppercase letters and numbers
  
    // Placeholder for CAPTCHA value
    const captchaHolder = obscureChars();
    setCaptchaValue(captchaHolder); // Set the generated CAPTCHA string
  
    // Get canvas context and clear previous drawing
    const drawSurface = canvasRef.current;
    const drawingTool = drawSurface.getContext("2d");
    drawingTool.clearRect(0, 0, drawSurface.width, drawSurface.height); // Reset the canvas
  
    // Set canvas background color or gradient
    const gradient = drawingTool.createLinearGradient(0, 0, drawSurface.width, drawSurface.height);
    gradient.addColorStop(0, "#f0f8ff");
    gradient.addColorStop(1, "#e6e6fa");
    drawingTool.fillStyle = gradient;
    drawingTool.fillRect(0, 0, drawSurface.width, drawSurface.height);
  
    // Customize CAPTCHA appearance: Fonts, colors, rotation
    drawingTool.font = "bold 32px Arial, sans-serif";
    drawingTool.fillStyle = "#333";
  
    // Add transformations for distortion
    for (let i = 0; i < captchaHolder.length; i++) {
      const char = captchaHolder[i];
      const x = 20 + i * 30 + Math.random() * 5; // Adjust x for spacing and randomness
      const y = 40 + Math.random() * 10; // Adjust y for randomness
      const angle = (Math.random() - 0.5) * 0.4; // Random rotation between -0.2 and 0.2 radians
  
      // Save current state, apply transformation, and draw each character
      drawingTool.save();
      drawingTool.translate(x, y);
      drawingTool.rotate(angle);
      drawingTool.fillText(char, 0, 0);
      drawingTool.restore();
    }
  
    // Add random noise lines
    for (let i = 0; i < 5; i++) {
      drawingTool.strokeStyle = `rgba(${Math.floor(Math.random() * 255)}, ${Math.floor(
        Math.random() * 255
      )}, ${Math.floor(Math.random() * 255)}, 0.8)`;
      drawingTool.lineWidth = 1.5;
      drawingTool.beginPath();
      drawingTool.moveTo(Math.random() * drawSurface.width, Math.random() * drawSurface.height);
      drawingTool.lineTo(Math.random() * drawSurface.width, Math.random() * drawSurface.height);
      drawingTool.stroke();
    }
  
    // Add random dots for further noise
    for (let i = 0; i < 50; i++) {
      drawingTool.fillStyle = `rgba(${Math.floor(Math.random() * 255)}, ${Math.floor(
        Math.random() * 255
      )}, ${Math.floor(Math.random() * 255)}, 0.5)`;
      drawingTool.beginPath();
      drawingTool.arc(
        Math.random() * drawSurface.width,
        Math.random() * drawSurface.height,
        Math.random() * 3,
        0,
        2 * Math.PI
      );
      drawingTool.fill();
    }
  
    return captchaHolder;
  };
  
  

  const query = "KYC";
  const {timestamp, signatureValue} = Signature(query)
  const config = {
    headers: {
      // "signature": process.env.REACT_APP_SIGNATURE,
      "signature": `${signatureValue}`,
      // "signature": '4056fb7dd7bde7e120ca3148b50b4264658248330806f873fa884c56dd1ccdd9',
      "Content-Type": 'application/json;charset=UTF-8',
      // "keep-alive": false,
    }
  };
   
  const handleSubmit = async (values) => {
    // const apiUrl = "https://192.72.53.70/KYC/Create";
    // const apiUrl = "https://192.72.53.70:5000/api/KYC/Create";
    //const apiUrl = "http://localhost:46087/api/KYC/Create";
    //Assign the front image to the frontImageString state
      values.frontImageValueHolder=frontImageString;
      values.backImageValueHolder=backImageString;
      values.signatureImageValueHolder=signatureImageString;

      //2 capture value
      values.frontImage2ValueHolder=frontImage2String;
      values.backImage2ValueHolder=backImage2String;
      values.signatureImage2ValueHolder=signatureImage2String;
      
      
for (const key in values) {
  //console.log("The values to be sent are  : "+key +" "+values[key]);
}

//console.log("The signatures image is:" + values.digitalSignatureValueHolder);

//const apiUrl = "http://10.129.2.15:9092/KYC/Create";
const apiUrl = `${window.location.origin}/api/KYC/Create`;
const objValues = {
  //"username": "KYCUI-TEST",
  "username": "KYCUI-TEST",      
  "applicationID": "KYCUI",
  "where": values,
  "action": "SAVE_DETAILS",
  "query": "KYC",
  "timestamp":`${timestamp}`
  // "encryptCols":["accountName", "accountNumber", "cardNumber", "branch", "email", "phone"]
}
const hashedObjValues = Encryption(JSON.stringify(objValues));
//console.log(">>>", timestamp)
await Axios.post(apiUrl, hashedObjValues, config).then(res => {
  // console.log('resp', res)
  if (res.data.response_message === "Customer details saved successfully!") {
    handleCloseSnackBar()
    handleOpenSuccess();
  } else {
    handleCloseSnackBar()
    handleOpenSnackError()
  }
})
  .catch(() => {
    handleCloseSnackBar()
    handleOpenSnackError();
  });
      
  }

  const ref = useRef(null);
  // Adding the front image
  const [frontImageString, setfrontImageString]= useState(""); //front image
  const [previewFrontImage, setPreviewFrontImage] = useState(null);
  const [selectedFrontImage, setSelectedFrontImage] = useState(null);

  //add send images state
  const [frontImage2String, setfrontImage2String]= useState("");
  const [previewFrontImage2, setPreviewFrontImage2] = useState(null);
  const [selectedFrontImage2, setSelectedFrontImage2] = useState(null);
  

  const handleImageUploadFront = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    setPreviewFrontImage(file);  
    if (file && file.type.includes('image') && file.size > 0 && file.size <= 2 * 1024 * 1024) {
      const imageUrl = URL.createObjectURL(file);
      setPreviewFrontImage(imageUrl);
      setSelectedFrontImage(imageUrl);
      ref.current.values.frontImageValueHolder = imageUrl;  
      reader.onloadend = () => {
        const base64Image = reader.result;
        //console.log(base64Image);
        setfrontImageString(base64Image);
      };
      reader.readAsDataURL(new Blob([file]));
    } else {
      alert('Please select a valid image file (less than 2MB in size).');
      //console.log('Image may be empty');
      setfrontImageString("");
      setPreviewFrontImage(null);
      ref.current.values.frontImageValueHolder = "";
    }
  };

  const handleImage2UploadFront = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    setPreviewFrontImage2(file);  
    if (file && file.type.includes('image') && file.size > 0 && file.size <= 2 * 1024 * 1024) {
      const imageUrl = URL.createObjectURL(file);
      setPreviewFrontImage2(imageUrl);
      setSelectedFrontImage2(imageUrl);
      ref.current.values.frontImage2ValueHolder = imageUrl;  
      reader.onloadend = () => {
        const base64Image = reader.result;
        //console.log(base64Image);
        setfrontImage2String(base64Image);
      };
      reader.readAsDataURL(new Blob([file]));
    } else {
      alert('Please select a valid image file (less than 2MB in size).');
      //console.log('Image may be empty');
      setfrontImage2String("");
      setPreviewFrontImage2(null);
      ref.current.values.frontImage2ValueHolder = "";
    }
  };

  //Add the Back Image
  const [backImageString, setbackImageString]= useState("");
  const [previewBackImage, setPreviewBackImage] = useState(null);
  const [selectedBackImage, setSelectedBackImage] = useState(null);
  const handleImageUploadBack = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    setPreviewBackImage(file);
  
    if (file && file.type.includes('image') && file.size > 0 && file.size <= 2 * 1024 * 1024) {
      const imageUrl = URL.createObjectURL(file);
      setPreviewBackImage(imageUrl);
      setSelectedBackImage(imageUrl);
      ref.current.values.backImageValueHolder = imageUrl;
  
      reader.onloadend = () => {
        const base64Image = reader.result;
        //console.log(base64Image);
        setbackImageString(base64Image);
      };
      reader.readAsDataURL(new Blob([file]));
    } else {
      alert('Please select a valid image file (less than 2MB in size).');
      //console.log('Image may be empty');
      setbackImageString("");
      setPreviewBackImage(null);
      ref.current.values.backImageValueHolder = "";
    }
  };

  const [backImage2String, setbackImage2String]= useState("");
  const [previewBackImage2, setPreviewBackImage2] = useState(null);
  const [selectedBackImage2, setSelectedBackImage2] = useState(null);



  const handleImage2UploadBack = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    setPreviewBackImage2(file);
  
    if (file && file.type.includes('image') && file.size > 0 && file.size <= 2 * 1024 * 1024) {
      const imageUrl = URL.createObjectURL(file);
      setPreviewBackImage2(imageUrl);
      setSelectedBackImage2(imageUrl);
      ref.current.values.backImage2ValueHolder = imageUrl;
  
      reader.onloadend = () => {
        const base64Image = reader.result;
        //console.log(base64Image);
        setbackImage2String(base64Image);
      };
      reader.readAsDataURL(new Blob([file]));
    } else {
      alert('Please select a valid image file (less than 2MB in size).');
      //console.log('Image may be empty');
      setbackImage2String("");
      setPreviewBackImage2(null);
      ref.current.values.backImage2ValueHolder = "";
    }
  };

  const [signatureImageString, setsignatureImageString]= useState("");//signature image
  const [previewSignatureImage, setPreviewSignatureImage] = useState(null);
  const [selectedSignatureImage, setSelectedSignatureImage] = useState(null);
  const handleImageUploadSignature = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    setPreviewSignatureImage(file);
  
    if (file && file.type.includes('image') && file.size > 0 && file.size <= 2 * 1024 * 1024) {
      const imageUrl = URL.createObjectURL(file);
      setPreviewSignatureImage(imageUrl);
      setSelectedSignatureImage(imageUrl);
      ref.current.values.signatureImageValueHolder = imageUrl;
  
      reader.onloadend = () => {
        const base64Image = reader.result;
        //console.log(base64Image);
        setsignatureImageString(base64Image)
      };
      reader.readAsDataURL(new Blob([file]));
    } else {
      alert('Please select a valid image file (less than 2MB in size).');
      //console.log('Image may be empty');
      setsignatureImageString("");
      setPreviewSignatureImage(null);
      ref.current.values.signatureImageValueHolder = "";
    }
  };

  const [signatureImage2String, setsignatureImage2String]= useState("");//signature image
  const [previewSignatureImage2, setPreviewSignatureImage2] = useState(null);
  const [selectedSignatureImage2, setSelectedSignatureImage2] = useState(null);

  const handleImage2UploadSignature = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    setPreviewSignatureImage2(file);
  
    if (file && file.type.includes('image') && file.size > 0 && file.size <= 2 * 1024 * 1024) {
      const imageUrl = URL.createObjectURL(file);
      setPreviewSignatureImage2(imageUrl);
      setSelectedSignatureImage2(imageUrl);
      ref.current.values.signatureImage2ValueHolder = imageUrl;
  
      reader.onloadend = () => {
        const base64Image = reader.result;
        //console.log(base64Image);
        setsignatureImage2String(base64Image)
      };
      reader.readAsDataURL(new Blob([file]));
    } else {
      alert('Please select a valid image file (less than 2MB in size).');
      //console.log('Image may be empty');
      setsignatureImage2String("");
      setPreviewSignatureImage2(null);
      ref.current.values.signatureImage2ValueHolder = "";
    }
  };
  //Adding a Signature
  //ADDING A DIGITAL SIGNATURE TO A FORM
  const signatureRef = useRef('');
  const [signatureRefValue, setSignatureRefValue]= useState('');
  const clearSignature = () => {
    signatureRef.current.clear();
    setSignatureRefValue('');
    ref.current.values.digitalSignatureValueHolder="";
    //console.log("The signature has been cleared");

  };
  const [previewDigitalSignature, setPreviewDigitalSignature] = useState(null);
  const handleSendSignature = () => {
    //console.log("Into handle signature method");
    if (signatureRef.current) {
      const base64ImageSignature = signatureRef.current.toDataURL('image/png').replace(/^data:image\/png;base64,/, 'data:application/octet-stream;base64,');
      setPreviewDigitalSignature(base64ImageSignature);
      //console.log(base64ImageSignature);
      setSignatureRefValue(base64ImageSignature);
      ref.current.values.digitalSignatureValueHolder=base64ImageSignature; 
    }else{
      //console.log("Failed to handle signature");
      ref.current.values.digitalSignatureValueHolder="";
    }
  };
  return (
    <Grid fluid style={{ paddingLeft: 10, paddingRight: 10 }}>

          <Formik
            initialValues={{
              formID: uniqueFormID(),
              accountName: '',
              accountNumber: '',
              alternativeSourceOfIncome: '',
              bankNameDeposit: '',
              branch: '',
              cardNumber: '',
              city: '',
              country: 'UG',
              currentEmployer: '',
              currentRole: '',
              date: currentDate(),
              dateOfBirth: '',
              depositAccountNames: '',
              depositAccountNumber: '',
              email: '',
              expiryDate: '',
              gender: '',
              idType: 'N',
              monthlyGrossIncome: '',
              nationality: 'UG',
              otherNames: '',
              otherNumber: '',
              otherSigningMandate: '',
              othersourcesOfIncome: '',
              periodWithWorkplace: '',
              phone: '',
              poBox: '',
              postalOffice: '',
              province: '',
              registeredNames: '',
              registeredNumber: '',
              maritalStatus: '',
              status: 'PENDING',
              signingMandate: '',
              surname: '',
              sourcesOfIncome: '',
              telecomName: '',
              village: '',
              workplaceAddress: '',
              zipcode: '',
              nokName: '',
              nokEmail: '',
              nokAddress: '',
              nokRelationship: '',
              nokPhone: '',
              zone: '',
              policy: false,

              //Adding the front image
              frontImageValueHolder: "",
              backImageValueHolder: "",
              signatureImageValueHolder: "",

              frontImage2ValueHolder: "",
              backImage2ValueHolder: "",
              signatureImage2ValueHolder: "",

              //digitalSignatureValueHolder:signatureRefValue,
              //digitalSignatureValueHolder:signatureImageString

              accountType: '',
              captchaInputValue: '',
              CaptchaActual: ''
            }}
            validationSchema={FormValidationSchema}
            innerRef={ref}
            onSubmit={handleSubmit}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              // handleSubmit,
              isSubmitting,
              isValid,
              dirty,
              touched,
              values,
            }) => {
              // console.log('values>>>', values)
              const numberLength = values.accountNumber.toString().length === 0 ? '' : values.accountNumber.toString().length;
              const idNumberLength = values.cardNumber.toString().length === 0 ? '' : values.cardNumber.toString().length;
              return (
                <form onSubmit={handleSubmit}>
                        <Backdrop className={classes.backdrop} open={openSnack}>
                          <CircularProgress color="inherit" />
                        </Backdrop>
                  <AlertDialogSlide otherNames={values.otherNames} openSuccess={openSuccess} handleCloseSuccess={handleCloseSuccess} formID={values.formID} />
                  <Snackbar
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'center',
                    }}
                    open={snackOpenError}
                    autoHideDuration={3000}
                    onClose={handleCloseSnackError}
                    key="topcenter"
                    action={
                      <React.Fragment>
                        <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseSnackError}>
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </React.Fragment>
                    }
                  >
                    <Alert onClose={handleCloseSnackError} severity="warning" className={classes.snackFont}>
                      Unable to submit now, Please try again in a few minutes or contact support.
                    </Alert>
                  </Snackbar>
                  <Row >
                    <Col xs={12} md={4} >
                      <Typography
                        color="textPrimary"
                        variant="h5"
                        className={classes.formTitle}
                        flexGrow={2}
                      >
                        Customer Information Update Form. <span className={classes.value}></span>
                      </Typography>
                    </Col>
                    <Col xs={12} md={4} >
                      <Questions values={values} depositValue={selectedValue} sourcesOfIncome={values.sourcesOfIncome} idType={values.idType} nationality={values.nationality} signingMandate={values.signingMandate} selectedValue={selectedValue} policy={values.policy} disabledValue={true} errors={errors} />
                    </Col>
                    <Col xs={12} md={4}>
                      <Tooltip title="FORM ID" arrow placement="top">
                        <Typography>
                          <textarea wrap="off" className={classes.formValue} variant="h1"
                            ref={textAreaRef} value={values.formID} >
                          </textarea>
                          <Tooltip title="Click to copy ID" arrow placement="top">
                            <FileCopyIcon onClick={copyCodeToClipboard} />
                          </Tooltip>
                        </Typography>
                      </Tooltip>
                    </Col>
                    <Col xs={12} md={4}>
                      {document.queryCommandSupported('copy') &&
                        <>

                          <Snackbar
                            anchorOrigin={{
                              vertical: 'top',
                              horizontal: 'center',
                            }}
                            open={snackOpen}
                            autoHideDuration={4000}
                            onClose={handleCloseSnack}
                            message=""
                            key="topcenter"
                            action={
                              <React.Fragment>
                                <IconButton size="small" aria-label="close" color="inherit" onClick={handleCloseSnack}>
                                  <CloseIcon fontSize="small" />
                                </IconButton>
                              </React.Fragment>
                            }
                          >
                            <Alert onClose={handleCloseSnack} severity="info" className={classes.snackFont}>
                              FORM ID has been Copied Succesfully!
                            </Alert>
                          </Snackbar>
                        </>
                      }
                    </Col>
                    {/* <Button color="secondary" onClick={fetchData} variant="contained" >Fetch</Button> */}
                  </Row>
                  <Grid
                    container
                    spacing={1}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      xs={12}
                    >
                      <TextField
                        //error={Boolean(touched.branch && errors.branch)}
                        error={Boolean(errors.branch)}
                        className={classes.halftextField}
                        label="Select Your Branch"
                        name="branch"
                        onChange={handleChange}
                        required
                        //helperText={touched.branch && errors.branch}
                        helperText={errors.branch}
                        select
                        SelectProps={{ native: true }}
                        value={values.branch}
                        variant="outlined"
                        id="elmt"
                        //adding the prop to change the size of the text field
                        size="small"
                      >
                        <option
                          key=''
                          value=''
                          disabled
                        >
                          Select Branch
                        </option>
                        {branches && branches.data.map((branch, index) => (
                          <option
                            key={index}
                            value={branch.SOL_ID}
                          >
                            {branch.SOL_DESC}
                          </option>
                        ))}
                      </TextField>

                      <TextField
                        className={classes.margin}
                        label="Branch Code"
                        margin="normal"
                        name="code"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        disabled
                        value={values.branch}
                        variant="outlined"
                        size="small"

                      />
                      <TextField
                        //error={Boolean(touched.accountNumber && errors.accountNumber)}
                        error={Boolean(errors.accountNumber)}
                        className={classes.margin}
                        //helperText={touched.accountNumber && errors.accountNumber}
                        helperText={errors.accountNumber}
                        label={`Account Number ${numberLength}`}
                        margin="normal"
                        name="accountNumber"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.accountNumber}
                        variant="outlined"
                        required
                        size="small"
                      />
                      <TextField
                        //error={Boolean(touched.accountName && errors.accountName)}
                        error={Boolean(errors.accountName)}
                        className={classes.margin}
                        //helperText={touched.accountName && errors.accountName}
                        helperText={errors.accountName}
                        label="Account Name / Title"
                        margin="normal"
                        name="accountName"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.accountName}
                        variant="outlined"
                        required
                        size="small"
                      />
                      {/**Adding the Account type field */}
                      <TextField
                          //error={Boolean(touched.gender && errors.gender)}
                          error={Boolean(errors.accountType)}
                          className={classes.halftextField}
                          label="Select Account type"
                          name="accountType"
                          onChange={handleChange}
                          required
                          //helperText={touched.gender && errors.gender}
                          helperText={errors.accountType}
                          select
                          SelectProps={{ native: true }}
                          value={values.accountType}
                          variant="outlined"
                          margin="normal"
                          onBlur={handleBlur}
                          size="small"
                        >
                          <option
                            key=''
                            value=''
                            disabled
                          >
                            {/* Select Gender */}
                          </option>
                          {accountTypes.map((option) => (
                            <option
                              key={option.value}
                              value={option.value}
                            >
                              {option.label}
                            </option>
                          ))}
                      </TextField>

                      <TextField
                        id="date"
                        label="Date"
                        type="date"
                        format={'DD/MM/YYYY'}
                        // disabled
                        // defaultValue="0000-00-00"
                        className={classes.textField}
                        onChange={handleChange}
                        value={values.date}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        required
                        size="small"
                      />
                      <Button variant="contained" fullWidth className={classes.details}><PersonOutlineIcon />&nbsp;APPLICANT DETAILS</Button>
                      <Grid
                        item
                        md={12}
                        xs={12}
                      >
                        <TextField
                          //error={Boolean(touched.surname && errors.surname)}
                          error={Boolean(errors.surname)}
                          className={classes.halftextField}
                          //helperText={touched.surname && errors.surname}
                          helperText={errors.surname}
                          label="Surname"
                          margin="normal"
                          name="surname"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.surname}
                          variant="outlined"
                          required
                          size="small"
                        />
                        <TextField
                          //error={Boolean(touched.otherNames && errors.otherNames)}
                          error={Boolean(errors.otherNames)}
                          className={classes.halftextField}
                          // fullWidth
                          label="Other Name(s)"
                          name="otherNames"
                          //helperText={touched.otherNames && errors.otherNames}
                          helperText={errors.otherNames}
                          onChange={handleChange}
                          margin="normal"
                          onBlur={handleBlur}
                          required
                          value={values.otherNames}
                          variant="outlined"
                          size="small"
                        />
                        <TextField
                          //error={Boolean(touched.gender && errors.gender)}
                          error={Boolean(errors.gender)}
                          className={classes.halftextField}
                          label="Select Gender"
                          name="gender"
                          onChange={handleChange}
                          required
                          //helperText={touched.gender && errors.gender}
                          helperText={errors.gender}
                          select
                          SelectProps={{ native: true }}
                          value={values.gender}
                          variant="outlined"
                          margin="normal"
                          onBlur={handleBlur}
                          size="small"
                        >
                          <option
                            key=''
                            value=''
                            disabled
                          >
                            {/* Select Gender */}
                          </option>
                          {states.map((option) => (
                            <option
                              key={option.value}
                              value={option.value}
                            >
                              {option.label}
                            </option>
                          ))}
                        </TextField>

                        <TextField
                          //error={Boolean(touched.maritalStatus && errors.maritalStatus)}
                          error={Boolean(errors.maritalStatus)}
                          className={classes.halftextField}
                          label="Select Marital Status"
                          name="maritalStatus"
                          onChange={handleChange}
                          required
                          //helperText={touched.maritalStatus && errors.maritalStatus}
                          helperText={errors.maritalStatus}
                          select
                          SelectProps={{ native: true }}
                          value={values.maritalStatus}
                          variant="outlined"
                          margin="normal"
                          onBlur={handleBlur}
                          size="small"
                        >
                          <option
                            key=''
                            value=''
                            disabled
                          >
                            {/* Select Marital Status */}
                          </option>
                          {statuses.map((status, index) => (
                            <option
                              key={index}
                              value={status.value}
                            >
                              {status.label}
                            </option>
                          ))}
                        </TextField>

                        <TextField
                          //error={Boolean(touched.idType && errors.idType)}
                          error={Boolean(errors.idType)}
                          className={classes.halftextField}
                          label="Select ID Type"
                          name="idType"
                          onChange={handleChange}
                          required
                          //helperText={touched.idType && errors.idType}
                          helperText={errors.idType}
                          select
                          placeholder="Select ID Type"
                          SelectProps={{ native: true }}
                          value={values.idType}
                          variant="outlined"
                          margin="normal"
                          onBlur={handleBlur}
                          size="small"
                        >
                          {/* <option
                            // key=''
                            value='N'
                            // disabled
                          >
                            National ID
                          </option> */}
                          {idTypes.map((type, index) => (
                            <option
                              key={index}
                              value={type.value}
                            >
                              {type.label}
                            </option>
                          ))}
                        </TextField>
                        <TextField
                          id="dateOfBirth"
                          label="Date of Birth"
                          type="date"
                          // defaultValue="0000-00-00"
                          className={classes.textField}
                          onChange={handleChange}
                          value={values.dateOfBirth}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          required
                          margin="normal"
                          onBlur={handleBlur}
                          error={Boolean(errors.dateOfBirth)}
                          helperText={errors.dateOfBirth}
                          size="small"
                        />
                        <TextField
                          //error={Boolean(touched.nationality && errors.nationality)}
                          error={Boolean(errors.nationality)}
                          
                          className={classes.halftextField}
                          label="Select Nationality"
                          name="nationality"
                          onChange={handleChange}
                          required
                          //helperText={touched.nationality && errors.nationality}
                          helperText={errors.nationality}
                          select
                          SelectProps={{ native: true }}
                          value={values.nationality}
                          variant="outlined"
                          margin="normal"
                          onBlur={handleBlur}
                          size="small"
                        >
                          <option
                            key=''
                            value='UG'
                          // disabled
                          >
                            Ugandan
                          </option>
                          {nationalities && nationalities.data.map((nation) => (
                            <option
                              key={nation.alpha_2_code}
                              value={nation.alpha_2_code}
                            >
                              {nation.nationality}
                            </option>
                          ))}
                        </TextField>
                        <TextField
                          //error={Boolean(touched.country && errors.country)}
                          error={Boolean(errors.country)}
                          className={classes.halftextField}
                          label="Select Country of Residence"
                          name="country"
                          onChange={handleChange}
                          required
                          //helperText={touched.country && errors.country}
                          helperText={errors.country}
                          select
                          SelectProps={{ native: true }}
                          value={values.country}
                          variant="outlined"
                          margin="normal"
                          onBlur={handleBlur}
                          size="small"
                        >
                          <option
                            // key=''
                            value='UG'
                          // disabled
                          >
                            Uganda
                          </option>

                          {countries && countries.data.map((country, index) => (
                            <option
                              key={index}
                              value={country.code}
                            // value={countries.data.filter(option => option.code.toLowerCase() === "UG".toLowerCase())}
                            >
                              {country.name}
                            </option>
                          ))}
                        </TextField>
                        {/* error={values.sourcesOfIncome !== "OT" ? null : Boolean(errors.othersourcesOfIncome)}
                          helperText={values.sourcesOfIncome !== "OT" ? null : errors.othersourcesOfIncome} */}
                        <TextField
                          //error={Boolean(touched.cardNumber && errors.cardNumber)}
                          //helperText={touched.cardNumber && errors.cardNumber
                          error={Boolean(errors.cardNumber)}
                          helperText={errors.cardNumber}
                          className={classes.halftextField}
                          // fullWidth
                          label={(values.idType === 'N' || values.nationality === 'UG' ? 'National ID Number (ID)' : values.idType === 'P' ? 'Passport Number' : values.idType === 'R' ? 'Refugee ID Number' : 'ID card number') + " " + idNumberLength }
                          name="cardNumber"
                          disabled={values.idType === '' || values.nationality === '' ||
                            (values.nationality === 'UG' && values.idType !== 'N')}
                          // placeholder="ID Card Number"
                          onChange={handleChange}
                          required
                          margin="normal"
                          onBlur={handleBlur}
                          value={values.cardNumber}
                          variant="outlined"
                          size="small"
                        />
                        <TextField
                          id="expiryDate"
                          label="ID Expiry Date"
                          type="date"
                          // defaultValue="0000-00-00"
                          className={classes.textField}
                          onChange={handleChange}
                          value={values.expiryDate}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          required
                          margin="normal"
                          onBlur={handleBlur}
                          size="small"
                        />
                      </Grid>
                      {/* <Alert severity="info">CONTACT DETAILS</Alert><br/> */}
                      <Button variant="contained" fullWidth className={classes.contacts}><ContactsOutlinedIcon />&nbsp;CONTACT DETAILS</Button>
                      <Grid
                        item
                        md={12}
                        xs={12}
                      >
                        <TextField
                          //error={Boolean(touched.phone && errors.phone)}
                          //helperText={touched.phone && errors.phone}
                          error={Boolean(errors.phone)}
                          helperText={errors.phone}
                          className={classes.halftextField}
                          label="Mobile Phone (Start with 256)"
                          name="phone"
                          margin="normal"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          required
                          value={values.phone}
                          variant="outlined"
                          size="small"
                          placeholder="Start with 256..."
                        />
                        
                        <TextField
                          //error={Boolean(touched.otherNumber && errors.otherNumber)}
                          //helperText={touched.otherNumber && errors.otherNumber}
                          error={Boolean(errors.otherNumber)}
                          helperText={errors.otherNumber}

                          className={classes.halftextField}
                          // fullWidth
                          label="Other Phone Number"
                          name="otherNumber"
                          onChange={handleChange}
                          margin="normal"
                          onBlur={handleBlur}
                          value={values.otherNumber}
                          variant="outlined"
                          required
                          size="small"
                        />
                        <TextField
                          //error={Boolean(touched.poBox && errors.poBox)}
                          //helperText={touched.poBox && errors.poBox}
                          error={Boolean(errors.poBox)}
                          helperText={errors.poBox}
                          className={classes.halftextField}
                          // fullWidth
                          label="P.O Box Number"
                          name="poBox"
                          onChange={handleChange}
                          margin="normal"
                          onBlur={handleBlur}
                          type='number'
                          value={values.poBox}
                          variant="outlined"
                          size="small"
                        />

                        <TextField
                          //error={Boolean(touched.postalOffice && errors.postalOffice)}
                          //helperText={touched.postalOffice && errors.postalOffice}
                          error={Boolean(errors.postalOffice)}
                          helperText={errors.postalOffice}
                          className={classes.halftextField}
                          // fullWidth
                          label="Postal Office Location"
                          name="postalOffice"
                          onChange={handleChange}
                          margin="normal"
                          onBlur={handleBlur}
                          value={values.postalOffice}
                          variant="outlined"
                          size="small"
                        />

                        <TextField
                          //error={Boolean(touched.email && errors.email)}
                          //helperText={touched.email && errors.email}
                          error={Boolean(errors.email)}
                          helperText={errors.email}

                          className={classes.halftextField}
                          // fullWidth
                          label="Email (Personal)"
                          name="email"
                          onChange={handleChange}
                          required
                          type='email'
                          margin="normal"
                          onBlur={handleBlur}
                          value={values.email}
                          variant="outlined"
                          size="small"
                        />
                      </Grid>
                      <Box
                        // alignItems="center"
                        display="flex"
                        ml={-1}
                      >
                        <Checkbox
                          checked={values.policy}
                          name="policy"
                          onChange={handleChange}
                        // error={values.policy === false ? true : false}
                        // helperText={values.policy === false ? "errors.policy" : 'null'}
                        />
                        <Typography
                          color="textSecondary"
                          variant="body1"
                        >
                          I guarantee that the accuracy of my contacts (mobile/email) provided above and consent to the use of my Phone No, and Email above for the bank's digital services.
                    {' '}<br />
                    I accordingly agree to hold the bank harmless from any loss/claims that may arise should the bank rely on them.

                  </Typography>
                      </Box>
                      <FormHelperText className={classes.policyError}>
                        {values.phone === '' || values.otherNumber === '' || values.email === ''
                          || values.policy === true ? null : "This is a required field, it must be checked"}
                      </FormHelperText>
                      <br />
                      {/* <Alert severity="info">CURRENT RESIDENTIAL DETAILS</Alert> */}
                      <Button variant="contained" fullWidth className={classes.contacts}><HomeOutlinedIcon />&nbsp;CURRENT RESIDENTIAL DETAILS</Button>
                      <Grid
                        item
                        md={12}
                        xs={12}
                      >
                        <TextField
                          //error={Boolean(touched.city && errors.city)}
                          error={Boolean(errors.city)}
                          className={classes.halftextField}
                          //helperText={touched.city && errors.city}
                          helperText={errors.city}
                          label="State / City / District"
                          name="city"
                          onChange={handleChange}
                          required
                          margin="normal"
                          onBlur={handleBlur}
                          value={values.city}
                          variant="outlined"
                          size="small"
                        />
                        <TextField
                          //error={Boolean(touched.province && errors.province)}
                          error={Boolean(errors.province)}
                          //helperText={touched.province && errors.province}
                          helperText={errors.province}
                          className={classes.halftextField}
                          // fullWidth
                          label="Province / County"
                          name="province"
                          onChange={handleChange}
                          value={values.province}
                          margin="normal"
                          onBlur={handleBlur}
                          required
                          variant="outlined"
                          size="small"
                        />
                        <TextField
                          //error={Boolean(touched.village && errors.village)}
                          error={Boolean(errors.village)}
                          //helperText={touched.village && errors.village}
                          helperText={errors.village}
                          className={classes.halftextField}
                          // fullWidth
                          label="Village"
                          name="village"
                          onChange={handleChange}
                          required
                          margin="normal"
                          onBlur={handleBlur}
                          value={values.village}
                          variant="outlined"
                          size="small"
                        />
                        <TextField
                          //error={Boolean(touched.zipcode && errors.zipcode)}
                          error={Boolean(errors.zipcode)}
                          //helperText={touched.zipcode && errors.zipcode}
                          helperText={errors.zipcode}
                          className={classes.halftextField}
                          // fullWidth
                          label="ZIP Code"
                          name="zipcode"
                          onChange={handleChange}
                          type='text'
                          pattern="[0-9]{5}"
                          margin="normal"
                          onBlur={handleBlur}
                          value={values.zipcode}
                          variant="outlined"
                          size="small"
                        />

                        <TextField
                          //error={Boolean(touched.zone && errors.zone)}
                          //helperText={touched.zone && errors.zone}
                          error={Boolean(errors.zone)}
                          helperText={errors.zone}
                          className={classes.halftextField}
                          // fullWidth
                          label="Zone / Plot No. / Street"
                          name="zone"
                          onChange={handleChange}
                          required
                          margin="normal"
                          onBlur={handleBlur}
                          value={values.zone}
                          variant="outlined"
                          size="small"
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  {/* <Alert severity="success">EMPLOYMENT / BUSINESS DETAILS</Alert> */}
                  <Button variant="contained" fullWidth className={classes.details}><BusinessOutlinedIcon />&nbsp;EMPLOYMENT / BUSINESS DETAILS</Button>
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <TextField
                      //error={Boolean(touched.sourcesOfIncome && errors.sourcesOfIncome)}
                      //helperText={touched.sourcesOfIncome && errors.sourcesOfIncome}
                      error={Boolean(errors.sourcesOfIncome)}
                      helperText={errors.sourcesOfIncome}
                      className={classes.halftextField}
                      label="Source of Income"
                      name="sourcesOfIncome"
                      onChange={handleChange}
                      required
                      select
                      margin="normal"
                      onBlur={handleBlur}
                      placeholder="Source of Income"
                      SelectProps={{ native: true }}
                      value={values.sourcesOfIncome}
                      variant="outlined"
                      size="small"
                    >
                      <option
                        key=''
                        value=''
                        disabled
                      >
                        {/* Source of Income */}
                      </option>
                      {sources && sources.map((source, index) => (
                        <option
                          key={index}
                          value={source.value}
                        >
                          {source.label}
                        </option>
                      ))}
                    </TextField>
                    <TextField
                      error={values.sourcesOfIncome !== "OT" ? null : Boolean(errors.othersourcesOfIncome)}
                      helperText={values.sourcesOfIncome !== "OT" ? null : errors.othersourcesOfIncome}
                      className={classes.halftextField}
                      // fullWidth
                      label="Enter Source of Income"
                      name="othersourcesOfIncome"
                      disabled={values.sourcesOfIncome !== 'OT'}
                      required={values.sourcesOfIncome === 'OT'}
                      onChange={handleChange}
                      value={values.othersourcesOfIncome}
                      variant="outlined"
                      margin="normal"
                      onBlur={handleBlur}
                      size="small"
                    />
                    <TextField
                      //error={Boolean(touched.alternativeSourceOfIncome && errors.alternativeSourceOfIncome)}
                      //helperText={touched.alternativeSourceOfIncome && errors.alternativeSourceOfIncome}                     
                      error={Boolean(errors.alternativeSourceOfIncome)}
                      helperText={errors.alternativeSourceOfIncome}

                      className={classes.halftextField}
                      // fullWidth
                      label="Any alternative Source of Income"
                      name="alternativeSourceOfIncome"
                      onChange={handleChange}
                      margin="normal"
                      onBlur={handleBlur}
                      value={values.alternativeSourceOfIncome}
                      variant="outlined"
                      size="small"
                    />
                    <TextField
                      error={values.sourcesOfIncome !== "S" ? null : Boolean(errors.currentEmployer)}
                      helperText={values.sourcesOfIncome !== "S" ? null : errors.currentEmployer}
                      className={classes.halftextField}
                      // fullWidth
                      label="Current Employer's Name"
                      name="currentEmployer"
                      onChange={handleChange}
                      disabled={values.sourcesOfIncome !== 'S'}
                      required={values.sourcesOfIncome === 'S'}
                      margin="normal"
                      onBlur={handleBlur}
                      value={values.currentEmployer}
                      variant="outlined"
                      size="small"
                    />
                    <TextField
                      //error={Boolean(touched.currentRole && errors.currentRole)}
                      //helperText={touched.currentRole && errors.currentRole}
                      error={Boolean(errors.currentRole)}
                      helperText={errors.currentRole}
                      className={classes.halftextField}
                      // fullWidth
                      label="Current Role / Title"
                      name="currentRole"
                      onChange={handleChange}
                      disabled={values.sourcesOfIncome === ''}
                      required
                      margin="normal"
                      onBlur={handleBlur}
                      value={values.currentRole}
                      variant="outlined"
                      size="small"
                    />
                    <TextField
                      //error={Boolean(touched.workplaceAddress && errors.workplaceAddress)}
                      //helperText={touched.workplaceAddress && errors.workplaceAddress}
                      error={Boolean(errors.workplaceAddress)}
                      helperText={errors.workplaceAddress}
                      className={classes.halftextField}
                      // fullWidth
                      label="Workplace Address"
                      name="workplaceAddress"
                      onChange={handleChange}
                      required
                      margin="normal"
                      onBlur={handleBlur}
                      value={values.workplaceAddress}
                      variant="outlined"
                      size="small"
                    />

                    <TextField
                      //error={Boolean(touched.periodWithWorkplace && errors.periodWithWorkplace)}
                      error={Boolean(errors.periodWithWorkplace)}
                      className={classes.halftextField}
                      label="Period with Workplace"
                      name="periodWithWorkplace"
                      onChange={handleChange}
                      required
                      //helperText={touched.periodWithWorkplace && errors.periodWithWorkplace}
                      helperText={errors.periodWithWorkplace}
                      select
                      // placeholder="Period with Workplace (Years)"
                      SelectProps={{ native: true }}
                      // margin="normal"
                      onBlur={handleBlur}
                      value={values.periodWithWorkplace}
                      variant="outlined"
                      size="small"
                    >
                      <option
                        key=''
                        value=''
                        disabled
                      >
                        {/* Period with Workplace */}
                      </option>
                      {periods && periods.map((period, index) => (
                        <option
                          key={index}
                          value={period.value}
                        >
                          {period.label}
                        </option>
                      ))}
                    </TextField>
                    <TextField
                      //error={Boolean(touched.monthlyGrossIncome && errors.monthlyGrossIncome)}
                      error={Boolean(errors.monthlyGrossIncome)}
                      className={classes.halftextField}
                      label="Monthly Gross Income"
                      name="monthlyGrossIncome"
                      onChange={handleChange}
                      required
                      //helperText={touched.monthlyGrossIncome && errors.monthlyGrossIncome}
                      helperText={errors.monthlyGrossIncome}
                      select
                      margin="normal"
                      onBlur={handleBlur}
                      placeholder="Monthly Gross Income"
                      SelectProps={{ native: true }}
                      value={values.monthlyGrossIncome}
                      variant="outlined"
                      size="small"
                    >
                      <option
                        key=''
                        value=''
                        disabled
                      >
                        {/* Monthly Gross Income */}
                      </option>
                      {incomes && incomes.map((income, index) => (
                        <option
                          key={index}
                          value={income.value}
                        >
                          {income.label}
                        </option>
                      ))}
                    </TextField>
                    <TextField
                      //error={Boolean(touched.signingMandate && errors.signingMandate)}
                      //helperText={touched.signingMandate && errors.signingMandate}                      
                      error={Boolean(errors.signingMandate)}
                      helperText={errors.signingMandate}
                      className={classes.halftextField}
                      label="Signing Mandate"
                      name="signingMandate"
                      onChange={handleChange}
                      required
                      select
                      SelectProps={{ native: true }}
                      margin="normal"
                      onBlur={handleBlur}
                      value={values.signingMandate}
                      variant="outlined"
                      size="small"
                    >
                      <option
                        key=''
                        value=''
                        disabled
                      >
                        {/* Signing Mandate */}
                      </option>
                      {mandates && mandates.map((mandate, index) => (
                        <option
                          key={index}
                          value={mandate.value}
                        >
                          {mandate.label}
                        </option>
                      ))}
                    </TextField>
                    <TextField
                      error={values.signingMandate !== "OT" ? null : (Boolean(errors.otherSigningMandate))}
                      helperText={values.signingMandate !== "OT" ? null : (errors.otherSigningMandate)}
                      className={classes.halftextField}
                      // fullWidth
                      label="Other Signing Mandate"
                      name="otherSigningMandate"
                      onChange={handleChange}
                      disabled={values.signingMandate !== "OT"}
                      required={values.signingMandate === "OT"}
                      value={values.otherSigningMandate}
                      variant="outlined"
                      margin="normal"
                      onBlur={handleBlur}
                      size="small"
                    />
                  </Grid>
                  {/* <Alert severity="success">
                  </Alert> */}
                  <Button variant="contained" fullWidth className={classes.details}><MonetizationOnOutlinedIcon />&nbsp;DEPOSIT PROTECTION FUND REQUIREMENTS</Button>
                  <span className={classes.textLower}>Please choose one of the two alternative payment options.</span><br/>
                  <FormControl component="fieldset">
                    {/* <FormLabel component="legend">Gender</FormLabel> */}
                    <RadioGroup required aria-label="deposit" name="deposit" value={selectedValue} onChange={handleDepositChoice}>
                      <FormControlLabel value="b" control={<Radio />} label="Alternative Active Bank Account Details(Not in PBU)" />
                      <FormControlLabel value="t" control={<Radio />} label="Alternative Registered Mobile Money Number Details" />
                    </RadioGroup>
                  </FormControl>
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <TextField
                      error={selectedValue === 'b' && values.bankNameDeposit === '' ? (true) : null}
                      helperText={selectedValue === 'b' && values.bankNameDeposit.toString().length < 1 ? "Bank Name is a required field" : null}
                      className={classes.halftextField1}
                      // fullWidth
                      disabled={selectedValue === 't' || selectedValue === ''}
                      label="Bank Name"
                      name="bankNameDeposit"
                      onChange={handleChange}
                      required={selectedValue === 'b'}
                      value={values.bankNameDeposit}
                      variant="outlined"
                      margin="normal"
                    // onBlur={handleBlur}
                    size="small"
                    />
                    <TextField
                      error={selectedValue === 'b' && values.depositAccountNames === '' ? (true) : null}
                      helperText={selectedValue === 'b' && values.depositAccountNames.toString().length < 1 ? "Account Name is a required field" : ''}
                      className={classes.halftextField1}
                      // fullWidth
                      disabled={selectedValue === 't' || selectedValue === ''}
                      label="Account Names"
                      name="depositAccountNames"
                      onChange={handleChange}
                      required={selectedValue === 'b'}
                      value={values.depositAccountNames}
                      variant="outlined"
                      margin="normal"
                      onBlur={handleBlur}
                      size="small"
                    />
                    <TextField
                      error={selectedValue === 'b' && values.depositAccountNumber === '' ? (true) : null}
                      helperText={selectedValue === 'b' && values.depositAccountNumber.toString().length < 1 ? "Account Number is a required field" : null}
                      className={classes.halftextField1}
                      // fullWidth
                      disabled={selectedValue === 't' || selectedValue === ''}
                      label="Account Number"
                      name="depositAccountNumber"
                      required={selectedValue === 'b'}
                      onChange={handleChange}
                      type='number'
                      value={values.depositAccountNumber}
                      variant="outlined"
                      margin="normal"
                      onBlur={handleBlur}
                      size="small"
                    /><br />
                    <TextField
                      error={selectedValue === 't' && values.telecomName === '' ? (true) : null}
                      helperText={selectedValue === 't' && values.telecomName.toString().length < 1 ? "Telecom Name is a required field" : null}
                      className={classes.halftextField1}
                      disabled={selectedValue === 'b' || selectedValue === ''}
                      // fullWidth
                      label="Telecom Name"
                      name="telecomName"
                      onChange={handleChange}
                      required={selectedValue === 't'}
                      value={values.telecomName}
                      variant="outlined"
                      margin="normal"
                    // onBlur={handleBlur}
                    size="small"
                    />
                    <TextField
                      error={selectedValue === 't' && values.registeredNames === '' ? (true) : null}
                      helperText={selectedValue === 't' && values.registeredNames.toString().length < 1 ? "Telecom Registered Name is a required field" : null}
                      className={classes.halftextField1}
                      // fullWidth
                      disabled={selectedValue === 'b' || selectedValue === ''}
                      label="Registered Name"
                      name="registeredNames"
                      onChange={handleChange}
                      required={selectedValue === 't'}
                      value={values.registeredNames}
                      variant="outlined"
                      margin="normal"
                      onBlur={handleBlur}
                      size="small"
                    />
                    <TextField
                      error={selectedValue === 't' && values.registeredNumber === '' ? (true) : null}
                      helperText={selectedValue === 't' && values.registeredNumber.toString().length < 1 ? "Telecom Registered Name is a required field" : null}
                      className={classes.halftextField1}
                      // fullWidth
                      disabled={selectedValue === 'b' || selectedValue === ''}
                      label="Registered Number"
                      name="registeredNumber"
                      onChange={handleChange}
                      required={selectedValue === 't'}
                      type='number'
                      value={values.registeredNumber}
                      variant="outlined"
                      margin="normal"
                      onBlur={handleBlur}
                      size="small"
                    />
                  </Grid>
                  <Button variant="contained" fullWidth className={classes.details}><GroupIcon />&nbsp;NEXT OF KIN</Button>
                  <Grid
                    item
                    md={12}
                    xs={12}
                  >
                    <TextField
                      //error={Boolean(touched.nokName && errors.nokName)}
                      //helperText={touched.nokName && errors.nokName}
                      error={Boolean(errors.nokName)}
                      helperText={errors.nokName}
                      className={classes.halftextField}
                      // fullWidth
                      label="Names"
                      name="nokName"
                      onChange={handleChange}
                      required
                      margin="normal"
                      onBlur={handleBlur}
                      value={values.nokName}
                      variant="outlined"
                      size="small"
                    />
                    <TextField
                      //error={Boolean(touched.nokAddress && errors.nokAddress)}
                      //helperText={touched.nokAddress && errors.nokAddress}
                      error={Boolean(errors.nokAddress)}
                      helperText={errors.nokAddress}
                      className={classes.halftextField}
                      // fullWidth
                      label="Address"
                      name="nokAddress"
                      onChange={handleChange}
                      required
                      margin="normal"
                      onBlur={handleBlur}
                      value={values.nokAddress}
                      variant="outlined"
                      size="small"
                    />
                    <TextField
                      //error={Boolean(touched.nokEmail && errors.nokEmail)}
                      //helperText={touched.nokEmail && errors.nokEmail}
                      error={Boolean(errors.nokEmail)}
                      helperText={errors.nokEmail}
                      className={classes.halftextField}
                      // fullWidth
                      label="Email"
                      name="nokEmail"
                      onChange={handleChange}
                      required
                      margin="normal"
                      onBlur={handleBlur}
                      value={values.nokEmail}
                      variant="outlined"
                      size="small"
                    />
                    <TextField
                      //error={Boolean(touched.nokRelationship && errors.nokRelationship)}
                      //helperText={touched.nokRelationship && errors.nokRelationship}
                      error={Boolean(errors.nokRelationship)}
                      helperText={errors.nokRelationship}
                      className={classes.halftextField}
                      // fullWidth
                      label="Relationship"
                      name="nokRelationship"
                      onChange={handleChange}
                      required
                      margin="normal"
                      onBlur={handleBlur}
                      value={values.nokRelationship}
                      variant="outlined"
                      size="small"
                    />
                    <TextField
                      //error={Boolean(touched.nokPhone && errors.nokPhone)}
                      //helperText={touched.nokPhone && errors.nokPhone}
                      error={Boolean(errors.nokPhone)}
                      helperText={errors.nokPhone}
                      className={classes.halftextField}
                      // fullWidth
                      label="Telephone No."
                      name="nokPhone"
                      onChange={handleChange}
                      required
                      margin="normal"
                      onBlur={handleBlur}
                      value={values.nokPhone}
                      variant="outlined"
                      size="small"
                    />
                  </Grid>
                  <Box my={2}>

                  </Box>
                  <Button variant="contained" fullWidth className={classes.details}><GroupIcon />&nbsp;IDENTIFICATION DETAILS</Button>
                  <br/>
                  <Row>
                    {
                    values.idType &&
                    <Col xs={12} md={6}>
                    <Card className={classes.selectCard} style={{ display: 'flex' }}>
                      <CardContent style={{ marginRight: 'auto' }}>
                        <FormControl //className={classes.formControl}
                        >
                        <label component="legend">Attach the Front face of the ID<span className={classes.mandatory} >&nbsp;*</span></label>
                        <TextField 
                            type="file" 
                            onChange={handleImageUploadFront} 
                            onBlur={handleBlur}
                            className="file-input" 
                            accept="image"
                            error={Boolean(errors.frontImageValueHolder)}
                            name="frontImageValueHolder"
                          />
                            <small className={classes.policyError}><ErrorMessage name="frontImageValueHolder" /></small>                            
                        </FormControl>
                      </CardContent>
                      {previewFrontImage && 
                        <CardMedia
                          component="img"
                          src={previewFrontImage}
                          alt="Front image"
                          style={{ width: '200px', height: '110px', objectFit: 'cover' }}
                        />    
                      }
                    </Card>
                    </Col>
                    }
                    {
                      values.idType &&
                      <Col xs={12} md={6}>
                      <Card className={classes.selectCard} style={{ display: 'flex' }}>
                        <CardContent style={{ marginRight: 'auto' }}>
                          <FormControl>
                          <label component="legend">Attach the Back face of the ID<span className={classes.mandatory} >&nbsp;*</span></label>
                              <TextField 
                              type="file" 
                              onChange={handleImageUploadBack} 
                              onBlur={handleBlur}
                              className="file-input" 
                              accept="image" 
                              error={Boolean(errors.backImageValueHolder)}
                              name="backImageValueHolder"
                              />
                              <small className={classes.policyError}><ErrorMessage name="backImageValueHolder" /></small>
                          </FormControl>
                        </CardContent>
                        {previewBackImage && 
                            <CardMedia
                              component="img"
                              src={previewBackImage}
                              alt="Block ATM Card"
                              style={{ width: '200px', height: '110px', objectFit: 'cover' }}
                              required
                            />
                        }
                      </Card>
                      </Col>
                    }
                  </Row>

                  {
                    values.idType &&
                    <Col xs={12} md={12}>
                    <Card className={classes.selectCard} style={{ display: 'flex' }}>
                      <CardContent style={{ marginRight: 'auto' }}>
                        <FormControl>
                        <label component="legend">Attach the Signature Photo<span className={classes.mandatory} >&nbsp;*</span></label>
                            <TextField 
                            type="file" 
                            onChange={handleImageUploadSignature} 
                            onBlur={handleBlur}
                            className="file-input" 
                            accept="image" 
                            error={Boolean(errors.signatureImageValueHolder)}
                            helperText={errors.signatureImageValueHolder}
                            name="signatureImageValueHolder"
                            />
                        </FormControl>
                      </CardContent>
                      {previewSignatureImage && 
                          <CardMedia
                            component="img"
                            src={previewSignatureImage}
                            alt="Signature"
                            //style={{ width: '30%', height: '20%', objectFit: 'fill' }}
                            style={{ width: '200px', height: '110px', objectFit: 'cover' }}
                            required
                          />
                      }
                    </Card>
                    </Col>
                  }

                  {/**Add more Images for Business Accounts*/}                  
                  <Row>
                    {
                    values.idType &&
                    <Col xs={12} md={6}>
                    <Card className={classes.selectCard} style={{ display: 'flex' }}>
                      <CardContent style={{ marginRight: 'auto' }}>
                        <FormControl //className={classes.formControl}
                        >
                        <label component="legend">Attach the Second Front face of the ID<span className={classes.mandatory} >&nbsp;*</span></label>
                        <TextField 
                            type="file" 
                            onChange={handleImage2UploadFront} 
                            onBlur={handleBlur}
                            className="file-input" 
                            accept="image"
                            error={Boolean(errors.frontImage2ValueHolder)}
                            name="frontImage2ValueHolder"
                        />
                            <small className={classes.policyError}><ErrorMessage name="frontImage2ValueHolder" /></small>                            
                        </FormControl>
                      </CardContent>
                      {previewFrontImage2 && 
                        <CardMedia
                          component="img"
                          src={previewFrontImage2}
                          alt="Front image2"
                          style={{ width: '200px', height: '110px', objectFit: 'cover' }}
                        />    
                      }
                    </Card>
                    </Col>
                    }
                    {
                      values.idType &&
                      <Col xs={12} md={6}>
                      <Card className={classes.selectCard} style={{ display: 'flex' }}>
                        <CardContent style={{ marginRight: 'auto' }}>
                          <FormControl>
                          <label component="legend">Attach the Second Back face of the ID<span className={classes.mandatory} >&nbsp;*</span></label>
                              <TextField 
                              type="file" 
                              onChange={handleImage2UploadBack} 
                              onBlur={handleBlur}
                              className="file-input" 
                              accept="image" 
                              error={Boolean(errors.backImage2ValueHolder)}
                              name="backImage2ValueHolder"
                              />
                              <small className={classes.policyError}><ErrorMessage name="backImage2ValueHolder" /></small>
                          </FormControl>
                        </CardContent>
                        {previewBackImage2 && 
                            <CardMedia
                              component="img"
                              src={previewBackImage2}
                              alt="Block ATM Card"
                              style={{ width: '200px', height: '110px', objectFit: 'cover' }}
                              required
                            />
                        }
                      </Card>
                      </Col>
                    }

                    {
                    values.idType &&
                    <Col xs={12} md={12}>
                    <Card className={classes.selectCard} style={{ display: 'flex' }}>
                      <CardContent style={{ marginRight: 'auto' }}>
                        <FormControl>
                        <label component="legend">Attach the Second Signature Photo<span className={classes.mandatory} >&nbsp;*</span></label>
                            <TextField 
                            type="file" 
                            onChange={handleImage2UploadSignature} 
                            onBlur={handleBlur}
                            className="file-input" 
                            accept="image" 
                            error={Boolean(errors.signatureImage2ValueHolder)}
                            helperText={errors.signatureImage2ValueHolder}
                            name="signatureImage2ValueHolder"
                            />
                        </FormControl>
                      </CardContent>
                      {previewSignatureImage2 && 
                          <CardMedia
                            component="img"
                            src={previewSignatureImage2}
                            alt="Signature2"
                            //style={{ width: '30%', height: '20%', objectFit: 'fill' }}
                            style={{ width: '200px', height: '110px', objectFit: 'cover' }}
                            required
                          />
                      }
                    </Card>
                    </Col>
                  }
                  </Row>
                  {/* Display CAPTCHA image */}
                  <Row>
                    <Col>
                    Confirm you are not a robot by filling 
                    </Col>
                    <Col>
                    <canvas 
                      ref={canvasRef} 
                      //width="200" 
                      height="50"
                      value={values.CaptchaActual=captchaValue}
                      onChange={handleChange}
                      
                      >
                    </canvas>
                    <TextField
                      error={Boolean(errors.captchaInputValue)}
                      helperText={errors.captchaInputValue}
                      className={classes.halftextField}
                      name="captchaInputValue"
                      onChange={handleChange}
                      required
                      margin="normal"
                      onBlur={handleBlur}
                      value={values.captchaInputValue}
                      variant="outlined"
                      size="small"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={generateCaptchaText} color="secondary">
                              <RefreshIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                    </Col>
                  </Row>
                  
                  <Col xs={12} md={12}>
                    <PreviewModal
                      onSubmitFunction={handleSubmit} handleToggleSnackBar={handleToggleSnackBar}
                      isSubmitting={isSubmitting} dirty={dirty} isValid={isValid}
                      fields={values} depositValue={selectedValue} errors={errors} />
                  </Col>

                <br/>

                </form>
              )
            }
            }
          </Formik>     
    </Grid>
  );
};

export default KycFormFields;
